import _has from "lodash/has";
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";

export default {
    components: {
        FacebookAuth: () => import(/* webpackChunkName: "facebook-auth"*/ "@c/facebook-auth.vue")
    },
    props: {
        useRouteHandler: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            handleQueryDefaultRoutes: {
                hibooks: { name: "subscription-audiobooks", params: {} },
                nonfiction:{ name: "subscription-book-insights", params: {} }
            },
            handleQueryDefaultActions: {
                gift: {
                    "hibooks":"hibooksSelectedGift",
                    "nonfiction": "nonfictionSelectedGift"
                },
                vuex: {
                    "nonfiction": "Application/setSelectedNonfictionGift"
                },
                campaignGitfs: {
                    "hibooks": "hibooksCampaignGifts",
                    "nonfiction": "nonfictionCampaignGifts"
                }
            }
        };
    },
    computed: {
        customQuery() {
            const query = { ...this.$route.query };
            delete query.redirect;
            return query;
        }
    },
    methods: {
        async $_verifyAccountEmail(userData) {
            const emailExists = await this.$store.dispatch("User/checkIfEmailExists", encodeURIComponent(userData.email_address));
            this.$_accountValidation(userData, emailExists);
        },
        // need to be overwritten
        // eslint-disable-next-line
        $_accountValidation(userData = {}, emailExists = false) {
            this.$_handleEmailAuth(userData);
        },
        $_handleEmailAuth(userData) {
            const login = axios.post("/v2/connect/email", userData);
            this.$_handleUserAuthentication(login, "email");
        },
        $_handleFacebookAuth(token = "") {
            const facebookLoginResponse = axiosAccountApi.post("/connect/facebook-memod/token", { access_token: token, response_type: "json" });
            this.$_handleUserAuthentication(facebookLoginResponse, "facebook");
        },
        $_handleUserAuthentication(authPromise, method = "email") {
            this.$store.dispatch("Application/showLoader", true);
            authPromise.then(({ data: user }) => {
                this.$_handleSuccessfullAuth(user, method);
            }).catch((error) => {
                this.$notify({
                    group: "app-notifications",
                    type: "error",
                    text: error.response.data.message,
                    duration: 5000
                });
            }).finally(() => {
                this.$store.dispatch("Application/showLoader", false);
            })
        },
        // need to be overwritten
        // eslint-disable-next-line
        $_handleSuccessfullAuth(user = {}, method = "email") {
            this.$store.dispatch("User/setToken", user.token);
            Cookies.set("token", user.token);
        },
        async $_handleNextRoute(route, defaultRoute) {

            if (route.query.redirect) {
                this.$router.replace({ path: route.query.redirect, query: { ...this.customQuery } });
                return;
            }
            let nextRoute = _cloneDeep(defaultRoute);

            const isEmailCampaign = route.query.campaign_id;
            if (isEmailCampaign) {
                await this.$store.dispatch("Application/updateDefaultCampaign", isEmailCampaign);
            }
            nextRoute = this.$_handleEmailCampaign(route, defaultRoute);

            this.$router.replace(nextRoute);
        },
        $_handleEmailCampaign(route, defaultRoute) {
            let nextEmailRoute = _cloneDeep(defaultRoute);
            const routes = _cloneDeep(this.handleQueryDefaultRoutes);
            const actions = _cloneDeep(this.handleQueryDefaultActions);
            routes[route.meta.group].params = { ...route.params };

            const audiobook = this.$_getEmailCampaignGift(route, actions);

            if (!_isEmpty(audiobook)) {
                this.$store.dispatch(actions.vuex[route.meta.group], audiobook);

                routes[route.meta.group].params.audiobook = audiobook;
                routes[route.meta.group].query = { ...route.query };

                nextEmailRoute = routes[route.meta.group] ;
            }

            return nextEmailRoute;
        },
        $_getEmailCampaignGift(route, actions) {
            const paramsAudiobook = _has(route, "params.audiobook") ? route.params.audiobook : {};
            const gift = this.$_getRouteSelectedGift(route, actions);

            return _isEmpty(gift) ? paramsAudiobook : gift;
        },
        $_getRouteSelectedGift(route, actions) {
            const audiobookId = route.query.audiobookId || route.params.audiobookId || route.query.audiobook_id || route.params.audiobook_id;

            const gifts = this.$store.state.Application[actions.campaignGitfs[route.meta.group]];

            const selectedGift = gifts.find(item => item.id == audiobookId);

            const gift = JSON.parse(sessionStorage.getItem(actions.gift[route.meta.group]));

            return _isEmpty(selectedGift) ? gift : selectedGift;
        }
    }
}
